export default __webpack_public_path__ + "static/media/gamers_v2.0548de0c.jpg";